import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import ModalImageThumbnail from 'LuxKit/Modal/ModalImageThumbnail'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import { ImageParams } from 'components/Common/ResponsiveImage/ResponsiveImage'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Group from 'components/utils/Group'
import LoyaltyTierBenefitAvailabilityMessageBanner from 'loyalty/components/LoyaltyTierBenefitAvailabilityMessageBanner'
import React from 'react'

const imageParams: ImageParams = {
  aspectRatio: '16:8',
  mobileWidth: '720px',
  fit: 'center',
}

interface Props {
  image: App.Image
}

function LandingPageLoyaltyAirportTransferBenefitsModal(props: Props) {
  const { image } = props

  return (
    <ModalBase size="L">
      <ModalHeader title="Free airport chauffeur service" />
      <ModalBody>
        <ModalImageThumbnail image={image} imageParams={imageParams} />
        <ModalContent>
          <Group direction="vertical" gap={32}>
            <LoyaltyTierBenefitAvailabilityMessageBanner benefitType="airport_transfer" />
            <BodyText variant="large">
              Start and end your journey smoothly with free private airport transfers in select destinations. No stress, just seamless service.
            </BodyText>
            <VerticalSpacer gap={8}>
              <Heading variant="heading4">How it works</Heading>
              <BodyText variant="large">
                When booking select overseas hotels, you'll have the option to add a private transfer during checkout. Once selected, your transfer will automatically be added to your booking at no additional cost.
              </BodyText>
            </VerticalSpacer>
          </Group>
        </ModalContent>
      </ModalBody>
    </ModalBase>
  )
}

export default LandingPageLoyaltyAirportTransferBenefitsModal
